@if (showLdr==true) {
<ds-loading></ds-loading>
}

<!-- Vehicle Slider Drawer -->
<nz-drawer
  [nzWidth]="'70%'"
  [nzClosable]="true"
  [nzVisible]="visibleVhclSldr"
  nzPlacement="right"
  nzTitle="Vehicle Dashboard"
  (nzOnClose)="visibleVhclSldr = false"
  class="dashbSlider"
>
  <ng-container *nzDrawerContent>
    @if (selectedVehicle) {
    <app-vehicle-slider [vechile]="selectedVehicle"></app-vehicle-slider>
    }
  </ng-container>
</nz-drawer>

<div
  class="heatmap-fullscreen"
  [class.no-vehicles]="!vehiclesList || vehiclesList.length === 0"
>
  <!-- Full Screen Map -->
  <div id="heatmap" class="map-fullscreen"></div>

  <!-- Top Overlay - Header + Filters -->
  <div class="top-overlay">
    <!-- Brand Accent Stripe -->
    <div class="header-accent-stripe"></div>
    <!-- Header Bar -->
    <div class="header-bar">
      <div class="header-left">
        <div class="header-icon">
          <i nz-icon nzType="heat-map" nzTheme="outline"></i>
        </div>
        <div class="header-text">
          <h1>Heatmap Analysis</h1>
          <div class="header-subtitle">
            <div class="subtitle-line"></div>
            <span>Location Intelligence</span>
          </div>
        </div>
      </div>
      <button (click)="toggleFilterPanel()" class="filter-toggle-btn">
        <i
          nz-icon
          [nzType]="filterPanelOpen ? 'up' : 'down'"
          nzTheme="outline"
        ></i>
        <span>{{ filterPanelOpen ? "Hide" : "Show" }} Filters</span>
      </button>
    </div>

    <!-- Filter Strip (Collapsible) -->
    <div class="filter-strip" [class.collapsed]="!filterPanelOpen">
      <form nz-form [formGroup]="heatform" class="filter-form-horizontal">
        <!-- ULB/Zone Selection -->
        <div class="filter-item">
          <label class="filter-label">{{ title }}</label>
          <nz-select
            nzShowSearch
            [(ngModel)]="selectedtenants"
            (ngModelChange)="ontntSelects($event)"
            [ngModelOptions]="{ standalone: true }"
            formControlName="ulbs"
            nzPlaceHolder="Select {{ title }}"
            nzSize="small"
          >
            @if (showAll) {
            <nz-option
              [nzLabel]="'All ' + title + 's'"
              [nzValue]="0"
            ></nz-option>
            } @for (t of tntLst; track t) {
            <nz-option [nzValue]="t.tnt_id" [nzLabel]="t.tnt_nm"></nz-option>
            }
          </nz-select>
        </div>

        <!-- Vehicle Group -->
        <div class="filter-item">
          <label class="filter-label">Group</label>
          <nz-select
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Group"
            formControlName="vhcl"
            (ngModelChange)="getCatLists($event)"
            nzSize="small"
          >
            <nz-option
              [nzLabel]="'All Groups'"
              [nzValue]="'select'"
            ></nz-option>
            @for (v of assrtGroupList; track v) {
            <nz-option
              [nzLabel]="v.asrt_grp_nm"
              [nzValue]="v.asrt_grp_id"
            ></nz-option>
            }
          </nz-select>
        </div>

        <!-- Vehicle Category -->
        <div class="filter-item">
          <label class="filter-label">Category</label>
          <nz-select
            nzShowSearch
            nzAllowClear
            nzPlaceHolder="Select Category"
            [(ngModel)]="asrtctry"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="onCategorySelect($event)"
            nzSize="small"
          >
            <nz-option [nzLabel]="'All Categories'" [nzValue]="0"></nz-option>
            @for (v of asrtCtgryList; track v) {
            <nz-option
              [nzLabel]="v.asrt_ctgry_nm"
              [nzValue]="v.asrt_ctgry_id"
            ></nz-option>
            }
          </nz-select>
        </div>

        <!-- Date Range -->
        <div class="filter-item filter-item-wide">
          <label class="filter-label">Date Range</label>
          <nz-range-picker
            [(ngModel)]="dateTime"
            (ngModelChange)="onChange($event)"
            formControlName="dtrng"
            [nzDisabledDate]="disabledDate"
            nzFormat="dd-MM-yyyy"
            nzSize="small"
          >
          </nz-range-picker>
        </div>

        <!-- Generate Button -->
        <button
          type="button"
          (click)="generatemap()"
          class="generate-btn-compact"
        >
          <i nz-icon nzType="heat-map" nzTheme="outline"></i>
          Generate
        </button>
      </form>
    </div>
  </div>

  <!-- Heatmap Legend Overlay - Bottom Center -->
  @if (heatmapLayer) {
  <div class="heatmap-legend">
    <div class="legend-title">Heatmap Intensity</div>
    <div class="legend-bar-wrapper">
      <span class="legend-label">Low</span>
      <div class="legend-gradient-bar"></div>
      <span class="legend-label">High</span>
    </div>
  </div>
  }

  <!-- Vehicles Overlay on Right Side -->
  @if (vehiclesList && vehiclesList.length > 0) {
  <div class="vehicles-panel">
    <div class="panel-header">
      <div class="panel-title">
        <i nz-icon nzType="car" nzTheme="outline"></i>
        <span>{{ asrt_ctgry_nm }}</span>
        <span class="vehicle-count">{{ vehiclesList.length }}</span>
      </div>
      <button class="close-btn" (click)="clearVehiclesList()">
        <i nz-icon nzType="close" nzTheme="outline"></i>
      </button>
    </div>
    <div class="vehicles-list">
      @for (vehicle of vehiclesList; track vehicle) {
      <button
        class="vehicle-card"
        [class.running]="vehicle.asrtglblId === 1 && vehicle.spd_ct > 0"
        [class.parked]="vehicle.asrtglblId === 1 && vehicle.spd_ct === 0"
        [class.offline]="vehicle.asrtglblId !== 1"
        (click)="openVehicleSlider(vehicle)"
      >
        <img
          [src]="
            'assets/images/markers/mapIcons/' + vehicle.icon_pathr + '.png'
          "
          class="vehicle-icon"
          onerror="this.src='assets/images/markers/mapIcons/truck_p.png'"
        />
        <div class="vehicle-info">
          <span class="vehicle-name">{{ vehicle.asrt_nm }}</span>
          @if (vehicle.asrt_ctgry_nm) {
          <span class="vehicle-category">{{ vehicle.asrt_ctgry_nm }}</span>
          }
          <span class="vehicle-status">
            {{
              vehicle.asrtglblId === 1
                ? vehicle.spd_ct > 0
                  ? vehicle.spd_ct + " km/h"
                  : "Parked"
                : "Offline"
            }}
          </span>
        </div>
      </button>
      }
    </div>
  </div>
  }
</div>
